import { HttpClient, HttpRequest } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { MatDialog } from '@angular/material/dialog';
import { VideoComponent } from '../video/video.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { VideostreamingComponent } from '../videostreaming/videostreaming.component';

CampuscctvserviceService

@Component({
  selector: 'app-campus',
  templateUrl: './campus.component.html',
  styleUrls: ['./campus.component.scss']
})
export class CampusComponent implements OnInit {
  @Input() id: any;
  campus: any;
  searchkey: string = '';
  public searchTerm: string = '';

  constructor(public campuscctvserviceservice: CampuscctvserviceService, private router: ActivatedRoute, private dailog: MatDialog, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    const id = this.id
    // const id=this.router.snapshot.params['id']
    this.spinner.show();
    this.campuscctvserviceservice.getCampusData(id).subscribe(
      {
        next: (HttpRequest: any) => {
          this.campus = HttpRequest
          console.log('data', this.campus);
          this.spinner.hide();
        },
        error: (err: any) => {
          console.log('Error', err);
          this.spinner.hide();
        },
        complete: () => {
          console.log('completed!');
        }
      }
    );
  }

  // (click)="openvideo(frame)"
  // openvideo(frame: any) {
  //   this.dailog.open(VideoComponent, {
  //     data: frame,
  //     width: '650px', height: '490px',
  //   })
  // }

  openvideostreaming(frame: any) {
    this.dailog.open(VideostreamingComponent, {
      data: frame,
      width: '90%', height: '80%',
    })
  }
  
}
